/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Shortage_Warning_Col_NameInputs */

const vi_packaging_shortage_warning_col_name = /** @type {(inputs: Packaging_Shortage_Warning_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư`)
};

/**

* @param {Packaging_Shortage_Warning_Col_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_shortage_warning_col_name = /** @type {((inputs?: Packaging_Shortage_Warning_Col_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Shortage_Warning_Col_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_shortage_warning_col_name(inputs)
});